<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <PortfolioManageCard />
  </div>
</template>

<script>
import Banner from "./component/Banner.vue";
// import PortfolioManageCard from "./component/PortfolioManageCard.vue";
import PortfolioManageCard from "./component/NewPortfolioManageCard.vue";

export default {
  components: {
    Banner,
    PortfolioManageCard,
  },
};
</script>

<style></style>
